import { persistImageUrl } from './itemMeta.js'

const IMAGE_MIME = /^image\//i

export function isImageMimeType(value) {
  const mime = String(value || '').split(';')[0].trim().toLowerCase()
  if (!mime) return true
  return IMAGE_MIME.test(mime)
}

export function normalizeImageCandidates(list = []) {
  const seen = new Set()
  const rows = []
  for (const item of Array.isArray(list) ? list : []) {
    const row = typeof item === 'string' ? { url: item } : (item && typeof item === 'object' ? { ...item } : null)
    if (!row) continue
    const url = persistImageUrl(row.url || row.src || '')
    if (!url || seen.has(url) || !isImageMimeType(row.content_type || row.mime)) continue
    seen.add(url)
    rows.push({ ...row, url })
  }
  return rows
}
